/**
 * Types for offline payment and sales synchronization queue
 */

import type { POSCartItem, POSSalePayment } from './pos';

// ============ Payment Callbacks (existing) ============

export interface QueuedPaymentCallback {
  id: string;
  transactionId: string;
  status: 'success' | 'failed' | 'cancelled';
  nsu?: string;
  authorizationCode?: string;
  cardBrand?: string;
  cardLastDigits?: string;
  errorMessage?: string;
  attempts: number;
  lastAttempt: string;
  createdAt: string;
  saleId?: string;
  provider: string;
  amount: number;
  paymentMethod: 'credit' | 'debit';
}

export interface SyncResult {
  id: string;
  success: boolean;
  error?: string;
  syncedAt?: string;
}

export interface OfflineSyncState {
  queuedItems: QueuedPaymentCallback[];
  isSyncing: boolean;
  lastSyncAttempt: string | null;
  failedSyncCount: number;
}

export const OFFLINE_QUEUE_KEY = 'offline_payment_callbacks';
export const MAX_RETRY_ATTEMPTS = 5;
export const RETRY_DELAY_MS = 30000; // 30 seconds

// ============ Offline Sales Queue (new) ============

export interface QueuedOfflineSale {
  id: string;
  items: POSCartItem[];
  payments: POSSalePayment[];
  customer_id?: string;
  customer_cpf?: string;
  customer_name?: string;
  salesperson_id?: string;
  salesperson_name?: string;
  session_id: string;
  company_id: string;
  total_value: number;
  /** Só informativo (cupom provisório e indicador): o reenvio manda desconto geral 0, como a venda ao vivo (PDV-FILA-DESCONTO) */
  discount_value: number;
  emit_nfce: boolean;
  attempts: number;
  lastAttempt: string;
  createdAt: string;
  errorMessage?: string;
  syncStatus: 'pending' | 'syncing' | 'synced' | 'failed';
  /** PDV-DUPLICADA (I.160): chave contra repetição; item antigo (antes da correção) não tem e nunca é reenviado sozinho */
  client_request_id?: string;
}

export interface OfflineSalesState {
  queuedSales: QueuedOfflineSale[];
  isSyncing: boolean;
  lastSyncAttempt: string | null;
}

export const OFFLINE_SALES_KEY = 'offline_sales_queue';
export const MAX_SALE_RETRY_ATTEMPTS = 10;
export const SALE_RETRY_DELAY_MS = 15000; // 15 seconds
